__turbopack_context__.v({
  "animateSlideUp": "BlogHero-module__51YZCG__animateSlideUp",
  "badge": "BlogHero-module__51YZCG__badge",
  "badgeContainer": "BlogHero-module__51YZCG__badgeContainer",
  "blink": "BlogHero-module__51YZCG__blink",
  "container": "BlogHero-module__51YZCG__container",
  "delay1": "BlogHero-module__51YZCG__delay1",
  "delay2": "BlogHero-module__51YZCG__delay2",
  "delay3": "BlogHero-module__51YZCG__delay3",
  "dot": "BlogHero-module__51YZCG__dot",
  "headline": "BlogHero-module__51YZCG__headline",
  "highlight": "BlogHero-module__51YZCG__highlight",
  "shine": "BlogHero-module__51YZCG__shine",
  "slideUp": "BlogHero-module__51YZCG__slideUp",
  "text": "BlogHero-module__51YZCG__text",
  "title": "BlogHero-module__51YZCG__title",
  "titleEmphasized": "BlogHero-module__51YZCG__titleEmphasized",
  "titleHighlight": "BlogHero-module__51YZCG__titleHighlight",
  "titleLine": "BlogHero-module__51YZCG__titleLine",
});
